module.exports = __webpack_public_path__ + "static/media/driver5.6f6aceac.png";